import { ForecastPerWeek } from '@domain/inventory/models/ForecastPerWeek';
import { ForecastPerWeekDTO } from '../../purchasing/dto/ForecastPerWeekDTO';
import { InboundMapper } from '../../purchasing/mappers/InboundMapper';
import { OutboundMapper } from '../../purchasing/mappers/OutboundMapper';

export class ForecastPerWeekMapper {
  static toModel(dto: ForecastPerWeekDTO): ForecastPerWeek {
    return {
      year: dto.year,
      week: dto.week,
      startInventory: dto.startInventory,
      endInventory: dto.endInventory,
      outbounds: dto.outbounds.map(outbound => OutboundMapper.toModel(outbound)),
      inbounds: dto.inbounds.map(inbound => InboundMapper.toModel(inbound)),
    };
  }

  static toDTO(model: ForecastPerWeek): ForecastPerWeekDTO {
    return {
      year: model.year,
      week: model.week,
      startInventory: model.startInventory,
      endInventory: model.endInventory,
      outbounds: model.outbounds.map(outbound => OutboundMapper.toDTO(outbound)),
      inbounds: model.inbounds.map(inbound => InboundMapper.toDTO(inbound)),
    };
  }
}
